<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperRequestsMaterials',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'requestsMaterialsModule',
    };
  },
};
</script>
